import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField/TextField';

export default function Identificacao({ formulario, setFormulario, optionsModalidades }) {
    //onChange para o campo de regional
    const onChangeModalidade = (e, select) => {
        const { name } = select;
        setFormulario({
            ...formulario,
            [name]: e,
        })
    }

    return (
        <div className='p-2 m-2'>
            <Row>
                <Col md="12" lg="12">
                    <TextField
                        maxLength={"150"}
                        label={"* Identificação"}
                        name={"identificacao"}
                        value={formulario.identificacao}
                        onChange={(e) => setFormulario({
                            ...formulario,
                            [e.target.name]: e.target.value
                        })}
                    />
                </Col>
                <Col md="12" lg="12">
                    <TextField
                        maxLength={"30"}
                        label={"* Modalidades"}
                        type="select"
                        options={optionsModalidades ?? []}
                        multiple
                        name="tbFormularioPGRSModalidades"
                        value={formulario.tbFormularioPGRSModalidades}
                        onChange={onChangeModalidade}
                    />
                </Col>
            </Row>
        </div>
    )
}
